<div fxLayout="column" fxLayoutGap="100px" fxLayoutAlign="center center">
  <mat-toolbar class="header-color" *ngIf="isLoggedIn === false">
    <span class="fill-horizontal-space"></span>
    <!-- <div class="logo-parent">
      <img src="../../assets/bankverve.jpg" style="width:80%;height: 80%;"/>
  </div> -->
    <mat-form-field>
      <mat-select [(value)]="selectedLanguage" (selectionChange)="onLanguageChange($event)">
        <mat-option *ngFor="let language of languages" [value]="language.value">
          {{language.displayText}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </mat-toolbar>
  <mat-toolbar class="header-color" *ngIf="isLoggedIn === true">
    <!--<mat-toolbar-row>-->
      <!-- <img src="../../assets/logo.png" class="header-logo"> 
      <span class="fill-horizontal-space"></span>-->
      <!-- <span class="fill-horizontal-space"></span> -->
      <!-- <span class="header-align">Bankverve&trade; CBS for {{bankName}}. <br>
        12 -A, 3rd floor, Above Express Hypermarket, B K Circle, JP Nagar 8th Phase, Bangalore, 560078 </span>
      <span class="fill-horizontal-space"></span>
      <mat-icon [matBadge]="authorisationCount" matBadgeColor="accent" class="mat-36">notifications</mat-icon>
    </mat-toolbar-row>-->
    <!--<mat-toolbar-row class="toolbar-height">-->
      <!-- <span class="fill-horizontal-space"></span> -->
      <!-- <span class="fill-horizontal-space"></span>
      Branch: {{homeBranch.code}} - {{homeBranch.name}}-->
      <!-- <mat-form-field class="one-sixth-size">
        <input matInput placeholder="Home Branch" [value]="homeBranch.code + ' - ' + homeBranch.name" readonly>
      </mat-form-field> -->
      <!-- <span class="fill-horizontal-space"></span>
      <span>12 -A, 3rd floor, Above Express Hypermarket, B K Circle, JP Nagar 8th Phase, Bangalore, 560078</span> -->
      <!-- <span class="fill-horizontal-space"></span>
      Date: {{currentDate | date: formats.DATE_FORMAT}} -->
      <!-- <mat-form-field class="one-sixth-size">
        <input matInput placeholder="Current Branch Date" [value]="currentDate | date: formats.DATE_FORMAT" readonly>
      </mat-form-field> -->
      <!-- <span class="fill-horizontal-space"></span>
      <mat-form-field appearance="none">
        <mat-select [(value)]="selectedBranchId" (selectionChange)="onBranchChange($event)"
          placeHolder="Current Branch">
          <mat-option *ngFor="let branch of branches" [value]="branch.id">
            {{branch.code}} - {{branch.name}}
          </mat-option>
        </mat-select>
      </mat-form-field> 
      <span class="fill-horizontal-space"></span>
    </mat-toolbar-row>-->

    <mat-toolbar-row class="toolbar-height">
      <button mat-icon-button (click)="sideNav.toggle()">
        <mat-icon class="mat-26">menu</mat-icon>
      </button>
      <button mat-icon-button (click)="goToHome()" matTooltip="{{'HEADER.HOME' | translate}}">
        <mat-icon class="mat-26">home</mat-icon>
      </button>
      
      <!-- <span class="user-font-size"> {{'HEADER.DATE' | translate}}: {{currentDate | date: formats.DATE_FORMAT}}</span> -->
      <button *ngIf="!showIconSelector" mat-icon-button (click)="goToVista()" matTooltip="{{'HEADER.VISTA' | translate}} ">
        <mat-icon class="mat-26">account_balance</mat-icon>
      </button>
      <button mat-icon-button (click)="goToLoanCalculator()" matTooltip="{{'HEADER.LOAN_CALCULATER' | translate}} ">
        <mat-icon class="mat-26">copyright</mat-icon>
      </button>
      <button mat-icon-button (click)="goToLoanCalculatornew()" matTooltip="{{'HEADER.LOAN_CALCULATER' | translate}} ">
        <mat-icon class="mat-26">copyright</mat-icon>
      </button>
      <button *ngIf="!showIconSelector" mat-icon-button (click)="goToLoanAccountStatement()" matTooltip="{{'HEADER.LOAN_ACCOUNT_STATEMENT' | translate}}">
        <mat-icon class="mat-26">description</mat-icon>
      </button>
      <button *ngIf="!showIconSelector" mat-icon-button (click)="goToCash()" matTooltip="{{'HEADER.CASH' | translate}}">
        <mat-icon class="mat-26">monetization_on</mat-icon>
      </button>

      <button *ngIf="!showIconSelector" mat-icon-button (click)="goToTransfer()" matTooltip="{{'HEADER.TRANSFER' | translate}}">
        <mat-icon class="mat-26">swap_horiz </mat-icon>
      </button>

      <!-- <button mat-icon-button (click)="gotoErpStatement()" matTooltip="Erp">
        <mat-icon>explicit</mat-icon>
      </button> -->
<!-- Conditionally display the button only if erprequired is true -->
<!-- <button  mat-icon-button (click)="gotoErpStatement()" matTooltip="Erp">
  <mat-icon>explicit</mat-icon>
</button> -->
<button *ngIf="erprequired" mat-icon-button (click)="gotoErpStatement()" matTooltip="{{'HEADER.ERP' | translate}}">
  <mat-icon>explicit</mat-icon>
</button>

<button *ngIf="!showIconSelector" mat-icon-button (click)="goToDashboarddata()"  matTooltip="{{'HEADER.DASHBOARD' | translate}} ">
  <mat-icon class="mat-26">widgets</mat-icon>
</button>

<button *ngIf="!showIconSelector" mat-icon-button (click)="goToChangeBranch()" matTooltip="Change Branch" class="icon-box">
        <mat-icon class="mat-26" style="padding-left:3px">sync_alt </mat-icon>
      </button>

      
      <button *ngIf="!showIconSelector" mat-icon-button (click)="goToDashboard()" matTooltip="Dashboard" class="icon-box">
        <mat-icon class="mat-26">dashboard</mat-icon>
      </button>

      <span class="users-font-sizes"> {{'HEADER.DATE' | translate}}: {{currentDate | date: formats.DATE_FORMAT}}</span>

      <div class="header-center-logo" *ngIf="!showIconSelector">
  <img
    src="/assets/sacco.png"
    alt="Multi Tenant"
    class="tv-bank-logo"
  >
</div>

<div class="header-center-logo1" *ngIf="showIconSelector">
  <img
    src="/assets/sacco.png"
    alt="Multi Tenant"
    class="tv-bank-logo"
  >
</div>

      <span class="fill-horizontal-space"></span>
      <!-- <div class="logo-parent">
        <img src="../../assets/bankverve.jpg" style="width:50%;height: 50%;"/>
    </div> -->


      <span class="users-font-sizes">   {{ nameroleId == 1 ? 'SHASHWATHA NIDHI' : bankName }}</span>


       <span class="user-font-size">
        {{'HEADER.BRANCH' | translate}}: {{currentBranch.code}} - {{currentBranch.name}}
       </span>
      
      <span>
       <button mat-button [matMenuTriggerFor]="profileMenu" class="user-font-size">{{loggedInUserName}}</button>
        <mat-menu #profileMenu="matMenu" [overlapTrigger]="false">
          <button mat-menu-item>{{'HEADER.PROFILE' | translate}}</button>
          <button mat-menu-item>{{'HEADER.HELP' | translate}}</button>
          <mat-form-field class="menu-item">
            <mat-select [(value)]="selectedLanguage" (selectionChange)="onLanguageChange($event)">
              <mat-option *ngFor="let language of languages" [value]="language.value">
                {{language.displayText}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </mat-menu>
        <!--<mat-icon [matBadge]="authorisationCount" matBadgeColor="accent" matBadgeSize="small" class="notifications-size">notifications</mat-icon> -->
     
        <button mat-icon-button (click)="logout()" matTooltip="{{'HEADER.LOGOUT' | translate}}">
          <mat-icon class="mat-26">power_settings_new</mat-icon>
        </button>
      </span>
    </mat-toolbar-row>
  </mat-toolbar>
</div>
